module.exports = "/_next/static/images/10c6f61825a733f5bb5deed2d7a02370-mastercard-right-lg.jpg";